// Lib
import {
    connect,
    DefaultRootState,
    MapDispatchToPropsParam,
    MapStateToPropsParam,
    MergeProps,
    Options,
} from 'react-redux';

// Constants
import { EditorStoreContext } from './EditorStoreProvider';

const editorStoreConnect = <
    StateProps = {},
    DispatchProps = {},
    OwnProps = {},
    MergedProps = {},
    State = DefaultRootState,
>(
    mapStateToProps: MapStateToPropsParam<StateProps, OwnProps, State> | undefined | null = null,
    mapDispatchToProps: MapDispatchToPropsParam<DispatchProps, OwnProps> | undefined | null = null,
    mergeProps: MergeProps<StateProps, DispatchProps, OwnProps, MergedProps> | undefined | null = null,
    options: Options<State, StateProps, OwnProps, MergedProps> = {},
) => {
    // @ts-ignore - Redux type definitions are missing some use-cases
    return connect(mapStateToProps, mapDispatchToProps, mergeProps, {
        ...options,
        context: EditorStoreContext,
        getDisplayName: (component) => `EditorStoreConnect(${component})`,
    });
};

export default editorStoreConnect;
